import { SALES_EMAIL_ADDRESS, COVERTREE_PHONE_NUMBER } from "../service_data";

export const ERROR_MESSAGE = {
  DEFAULT: `Sorry, something went wrong. Please try again or call us at ${COVERTREE_PHONE_NUMBER}.`,

  ACTIVE_FIRE_DANGER:
    "Sorry, your property is not eligible due to an active wildfire in the area. Please check back in the future once the event has ended and you have confirmed the status of the home you are trying to quote.",

  HIGH_RISK_FIRE_DANGER:
    "Sorry, your property is not eligible due to a high risk of wildfire. Please seek out another Insurance Carrier.",

  GEO_ERROR: `We couldn't find your home. Please call one of our team members for support at ${COVERTREE_PHONE_NUMBER}.`,

  AGENT_NOT_ELIGIBLE: (state: string) =>
    `There seems to be an issue with your license or the license/appointment of your agency in ${state}. If you believe this is an error, please contact us at ${SALES_EMAIL_ADDRESS}.`,
  APPOINTMENT_NOT_REQUESTED_IN_NON_JIT: (state: string) =>
    `Access in ${state} was not requested. Please contact us at ${SALES_EMAIL_ADDRESS} to resolve this.`,
  REJECTED_IN_JIT: (state: string) =>
    `Your appointment in ${state} was rejected. If you believe this is an error, please contact us at ${SALES_EMAIL_ADDRESS}.`,
  NOT_APPOINTED_IN_NON_JIT: (state: string) =>
    `Your appointment in ${state} is still being processed. No action is needed right now - we’ll send you a follow-up email with confirmation as soon as it’s complete.`,
};
